// Class: openfl.display._ShaderData.ShaderData_Impl_

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var ShaderData_Impl_ = function(){}

// Meta

ShaderData_Impl_.__name__ = "openfl.display._ShaderData.ShaderData_Impl_";
ShaderData_Impl_.__isInterface__ = false;
ShaderData_Impl_.prototype = {
	
};
ShaderData_Impl_.prototype.__class__ = ShaderData_Impl_.prototype.constructor = $hxClasses["openfl.display._ShaderData.ShaderData_Impl_"] = ShaderData_Impl_;

// Init



// Statics

ShaderData_Impl_._new = function(byteArray) {
	var this1 = { };
	return this1;
}


// Export

exports.default = ShaderData_Impl_;